<template>
  <div class="slide stars_wrapper zoom" v-parallax-fit="stars_wrapper">
    <div class="star star1" v-parallax-fit="star1"></div>
    <div class="star star2" v-parallax-fit="star2"></div>
    <div class="star star2_1" v-parallax-fit="star2"></div>
    <div class="star star2_2" v-parallax-fit="star1"></div>
    <div class="star star3" v-parallax-fit="star3"></div>
    <div class="star star3_1" v-parallax-fit="star4"></div>
    <div class="star star4" v-parallax-fit="star4"></div>
    <div class="star star4_1" v-parallax-fit="star4_1"></div>
    <div class="star star5" v-parallax-fit="star5"></div>
    <div class="star star5_1" v-parallax-fit="star5_1"></div>
    <div class="star star5_2" v-parallax-fit="star2"></div>

    <div class="star star6" v-parallax-fit="star6"></div>
    <div class="star star6_1" v-parallax-fit="star6"></div>
    <div class="star star6_2" v-parallax-fit="star6"></div>
    <div class="star star6_3" v-parallax-fit="star9"></div>
    <div class="star star7" v-parallax-fit="star7"></div>
    <div class="star star8" v-parallax-fit="star8"></div>
    <div class="star star8_1" v-parallax-fit="star6"></div>
    <div class="star star8_2" v-parallax-fit="star7"></div>
    <div class="star star9" v-parallax-fit="star9"></div>
    <div class="star star9_1" v-parallax-fit="star9"></div>
    <div class="star star9_2" v-parallax-fit="star8"></div>

    <div class="star star10" v-parallax-fit="star10"></div>
    <div class="star star10_1" v-parallax-fit="star10"></div>
    <div class="star star10_2" v-parallax-fit="star10"></div>
    <div class="star star11" v-parallax-fit="star11"></div>
    <div class="star star11_1" v-parallax-fit="star10"></div>
    <div class="star star11_2" v-parallax-fit="star11"></div>
    <div class="star star11_3" v-parallax-fit="star10"></div>
    <div class="star star11_4" v-parallax-fit="star12"></div>
    <div class="star star11_5" v-parallax-fit="star11"></div>
    <div class="star star12" v-parallax-fit="star12"></div>
  </div>
</template>

<script>
export default {
  name: 'slide18',
  data() {
    return {
      stars_wrapper: [
        {
          start: 19000,
          end: 21000,
          fromStyle: { transform: 'translateY(0px) translateX(0px) rotateZ(0deg)' },
          toStyle: { transform: 'translateY(1400px) translateX(500px) rotateZ(45deg)' },
          easing: 'linear'
        },
      ],
      star1: [
        {
          start: 17000,
          end: 17050,
          fromStyle: { transform: 'scale(3)', opacity: 0 },
          toStyle: { transform: 'scale(1)', opacity: 1 },
          easing: 'linear'
        },
      ],
      star2: [
        {
          start: 17100,
          end: 17150,
          fromStyle: { transform: 'scale(3)', opacity: 0 },
          toStyle: { transform: 'scale(1)', opacity: 1 },
          easing: 'linear'
        },
      ],
      star3: [
        {
          start: 17200,
          end: 17250,
          fromStyle: { transform: 'scale(3)', opacity: 0 },
          toStyle: { transform: 'scale(1)', opacity: 1 },
          easing: 'linear'
        },
      ],
      star4: [
        {
          start: 17300,
          end: 17350,
          fromStyle: { transform: 'scale(3)', opacity: 0 },
          toStyle: { transform: 'scale(1)', opacity: 1 },
          easing: 'linear'
        },
      ],
      star4_1: [
        {
          start: 17400,
          end: 17450,
          fromStyle: { transform: 'scale(3)', opacity: 0 },
          toStyle: { transform: 'scale(1)', opacity: 1 },
          easing: 'linear'
        },
      ],
      star5: [
        {
          start: 17500,
          end: 17550,
          fromStyle: { transform: 'scale(3)', opacity: 0 },
          toStyle: { transform: 'scale(1)', opacity: 1 },
          easing: 'linear'
        },
      ],
      star5_1: [
        {
          start: 17600,
          end: 17650,
          fromStyle: { transform: 'scale(3)', opacity: 0 },
          toStyle: { transform: 'scale(1)', opacity: 1 },
          easing: 'linear'
        },
      ],
      star6: [
        {
          start: 17500,
          end: 17550,
          fromStyle: { transform: 'scale(3)', opacity: 0 },
          toStyle: { transform: 'scale(1)', opacity: 1 },
          easing: 'linear'
        },
      ],
      star7: [
        {
          start: 17550,
          end: 17600,
          fromStyle: { transform: 'scale(3)', opacity: 0 },
          toStyle: { transform: 'scale(1)', opacity: 1 },
          easing: 'linear'
        },
      ],
      star8: [
        {
          start: 17600,
          end: 17650,
          fromStyle: { transform: 'scale(3)', opacity: 0 },
          toStyle: { transform: 'scale(1)', opacity: 1 },
          easing: 'linear'
        },
      ],
      star9: [
        {
          start: 17650,
          end: 17700,
          fromStyle: { transform: 'scale(3)', opacity: 0 },
          toStyle: { transform: 'scale(1)', opacity: 1 },
          easing: 'linear'
        },
      ],
      star10: [
        {
          start: 18000,
          end: 18050,
          fromStyle: { transform: 'scale(3)', opacity: 0 },
          toStyle: { transform: 'scale(1)', opacity: 1 },
          easing: 'linear'
        },
      ],
      star11: [
        {
          start: 18050,
          end: 18100,
          fromStyle: { transform: 'scale(3)', opacity: 0 },
          toStyle: { transform: 'scale(1)', opacity: 1 },
          easing: 'linear'
        },
      ],
      star12: [
        {
          start: 18100,
          end: 18150,
          fromStyle: { transform: 'scale(3)', opacity: 0 },
          toStyle: { transform: 'scale(1)', opacity: 1 },
          easing: 'linear'
        },
      ],
    };
  }
}
</script>

<style lang="scss" scoped>
.star {
    position: fixed;
    transform-origin: center;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/RedMark.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    transition: 0.3s;
    z-index: 5;
    width: 35px;
    height: 35px;
    @media(max-width: 600px) {
      width: 4vw;
      height: 4vw;
    }
}
.stars_wrapper {
  z-index: 11;
  width: 100%;
  height: 100%;
  position: fixed;
  pointer-events: none;
  transition: 0.6s;
  @media(max-width: 400px) {
    zoom: 0.8;
  }
}
.star1 {
    left: calc(50% - 133px);
    top: calc(50% - 56px);
    @media(max-width:600px) {
      top: calc(50% - 12px);
    }
}
.star2 {
  left: calc(50% - 70px);
  top: calc(50% + 34px);
  @media(max-width: 600px) {
    top: calc(50% + 114px);
  }
}
.star2_1 {
  left: calc(50% - 132px);
  top: calc(50% + 76px);
  @media(max-width: 600px) {
    top: calc(50% + 106px);
  }
}
.star2_2 {
  left: calc(50% - 115px);
  top: calc(50% + 4px);
  @media(max-width: 600px) {
    top: calc(50% + 54px);
  }
}
.star3 {
  left: calc(50% - 67px);
  top: calc(50% - 92px);
  @media(max-width: 600px) {
    top: calc(50% - 50px);
  }
}
.star3_1 {
  left: calc(50% - 47px);
  top: calc(50% - 32px);
}
.star4 {
  left: calc(50% - 186px);
  top: calc(50% + 68px);
  @media(max-width: 600px) {
    left: 30%;
  }
}
.star4_1 {
  left: calc(50% - 136px);
  top: calc(50% + 148px);
}
.star5 {
  left: calc(50% - 110px);
  top: calc(50% - 186px);
  @media(max-width: 600px) {
    top: calc(50% - 16px);
  }
}
.star5_1 {
  left: calc(50% - 230px);
  top: calc(50% - 105px);
  @media(max-width: 600px) {
    left: calc(50% - 150px);
    top: calc(50% + 35px);
  }
}
.star5_2 {
  left: calc(50% - 164px);
  top: calc(50% - 136px);
  @media(max-width: 600px) {
    left: calc(50% - 54px);
    top: calc(50% + 24px);
  }
}

.star6 {
  left: calc(50% + 233px);
  top: calc(50% - 155px);
  @media(max-width: 600px) {
    left: 29%;
    top: calc(50% - 12px);
  }
}
.star6_1 {
  left: calc(50% + 173px);
  top: calc(50% - 265px);
  @media(max-width: 600px) {
    left: calc(50% + 113px);
    top: calc(50% - 65px);
  }
}
.star6_2 {
  left: calc(50% + 3px);
  top: calc(50% - 185px);
  @media(max-width: 600px) {
    left: calc(50% + 3px);
    top: calc(50% + 85px);
  }
}
.star6_3 {
  left: calc(50% + 263px);
  top: calc(50% - 265px);
  @media(max-width: 600px) {
    left: calc(50% + 23px);
    top: calc(50% - 5px);
  }
}
.star7 {
  left: calc(50% + 263px);
  top: calc(50% - 97px);
  @media(max-width: 600px) {
    left: calc(50% + 73px);
    top: calc(50% + 53px);
  }
}
.star8 {
  left: calc(50% + 340px);
  top: calc(50% - 63px);
  @media(max-width: 600px) {
    left: calc(50% + 160px);
    top: calc(50% + 77px);
  }
}
.star8_1 {
  left: calc(50% + 390px);
  top: calc(50% - 123px);
  @media(max-width: 600px) {
    left: calc(50% + 70px);
    top: calc(50% - 83px);
  }
}
.star8_2 {
  left: calc(50% + 380px);
  top: calc(50% + 17px);
  @media(max-width: 600px) {
    left: 74%;
  }
}
.star9 {
  left: calc(50% + 240px);
  top: calc(50% - 17px);
  @media(max-width: 600px) {
    left: 65%;
    top: calc(50% + 3px);
  }
}
.star9_1 {
  left: calc(50% + 310px);
  top: calc(50% - 17px);
  @media(max-width: 600px) {
    left: calc(50% - 20px);
    top: calc(50% - 67px);
  }
}
.star9_2 {
  left: calc(50% + 310px);
  top: calc(50% + 93px);
  @media(max-width: 600px) {
    left: 45%;
    top: calc(50% + 15px);
  }
}
.star10 {
  left: calc(50% + 90px);
  top: calc(50% - 27px);
}
.star10_1 {
  left: calc(50% + 20px);
  top: calc(50% - 57px);
}
.star10_2 {
  left: calc(50% + 140px);
  top: calc(50% + 13px);
}
.star11 {
  left: calc(50% + 119px);
  top: calc(50% - 107px);
  @media(max-width: 600px) {
    left: 47%;
    top: calc(50% - 15px);
  }
}
.star11_1 {
  left: calc(50% + 119px);
  top: calc(50% - 227px);
  @media(max-width: 600px) {
    left: calc(50% + 9px);
    top: calc(50% + 23px);
  }
}
.star11_2 {
  left: calc(50% + 69px);
  top: calc(50% - 67px);
}
.star11_3 {
  left: calc(50% + 51px);
  top: calc(50% - 130px);
  @media(max-width: 600px) {
    left: 57%;
    top: calc(50% + 50px);
  }
}
.star11_4 {
  left: calc(50% + 129px);
  top: calc(50% - 177px);
  @media(max-width: 600px) {
    top: calc(50% - 27px);
  }
}
.star11_5 {
  left: calc(50% + 169px);
  top: calc(50% - 67px);
  @media(max-width: 600px) {
    left: 36%;
    top: calc(50% + 61px);
  }
}
.star12 {
  left: calc(50% - 16px);
  top: calc(50% + 83px);
}

</style>
